"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSyncConfig = void 0;
const react_1 = require("react");
const context_1 = require("../context");
const useSyncConfig = () => {
    const { selectedOrgUser } = (0, react_1.useContext)(context_1.OrganizationContext);
    const [isSaving, setIsSaving] = (0, react_1.useState)(false);
    // Org settings are already loaded with the workspace; selectedOrgUser is a
    // stable instance per org, so this config object is stable across renders.
    const config = (0, react_1.useMemo)(() => selectedOrgUser
        ? {
            syncMode: selectedOrgUser.getEmrSyncMode(),
            internalGroupIds: selectedOrgUser.getEmrSyncInternalGroupIds(),
            enableEmrSync: selectedOrgUser.isEmrSyncEnabled(),
        }
        : null, [selectedOrgUser]);
    const save = (changes) => __awaiter(void 0, void 0, void 0, function* () {
        if (!selectedOrgUser)
            throw new Error("No organization selected");
        try {
            setIsSaving(true);
            yield selectedOrgUser.updateEmrSettings(changes);
        }
        finally {
            setIsSaving(false);
        }
    });
    return { config, isLoading: false, isSaving, save };
};
exports.useSyncConfig = useSyncConfig;
